import React, { useState, useEffect, useRef } from 'react';
import './skills.css';

const SkillBar = ({ skill, percentage, url }) => {
  const [width, setWidth] = useState(0);
  const skillRef = useRef(null);
  const animationRef = useRef(null);
  const startTimeRef = useRef(null);

  useEffect(() => {
    const currentSkillRef = skillRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          // Démarrer l'animation
          startTimeRef.current = performance.now();
          const duration = 800; // 0.8 secondes - plus rapide
          
          const animate = (timestamp) => {
            if (!startTimeRef.current) startTimeRef.current = timestamp;
            const elapsed = timestamp - startTimeRef.current;
            const progress = Math.min(elapsed / duration, 1);
            const currentWidth = Math.floor(progress * percentage);
            
            setWidth(currentWidth);
            
            if (progress < 1) {
              animationRef.current = requestAnimationFrame(animate);
            }
          };
          
          animationRef.current = requestAnimationFrame(animate);
        } else {
          // Réinitialiser
          cancelAnimationFrame(animationRef.current);
          setWidth(0);
          startTimeRef.current = null;
        }
      },
      { threshold: 0.5 }
    );

    if (currentSkillRef) observer.observe(currentSkillRef);

    return () => {
      if (currentSkillRef) observer.unobserve(currentSkillRef);
      cancelAnimationFrame(animationRef.current);
    };
  }, [percentage]);

  return (
    <div className="skill-item" ref={skillRef}>
      <div className="skill-header"  id='skill'>
        <div className="skill-icon"> <img src={url} alt="" /> </div>
        <div className="skill-info">
          <span className="skill-name">{skill}</span>
          <span className="skill-percentage">{width}%</span>
        </div>
      </div>
      <div className="skill-bar-container">
        <div 
          className="skill-bar" 
          style={{ width: `${width}%` }}
          role="progressbar"
          aria-valuenow={width}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  );
};
const SkillsSection = () => {
  const skills = [
    { name: 'HTML', level: 95, url:'/assets/img-skills/icons8-html-5-48.png' },
    { name: 'CSS', level: 95, url:'/assets/img-skills/icons8-css-24.png' },
    { name: 'JavaScript', level: 90 , url:'/assets/img-skills/icons8-javascript-48.png'},
    { name: 'React', level: 90, url:'/assets/img-skills/icons8-react-js-40.png' },
    { name: 'Node.js', level: 90, url:'/assets/img-skills/icons8-nodejs-48.png' },
    { name: 'Python', level: 90, url:'/assets/img-skills/icons8-python-48.png' },
    { name: 'Django', level: 90, url:'/assets/img-skills/icons8-django-24.png' },
    { name: 'Photoshop', level: 95, url:'/assets/img-skills/icons8-photoshop-48.png' },
    { name: 'Microsoft office', level: 90, url:'/assets/img-skills/icons8-microsoft-office-48.png' },
  ];

  return (
    <section className="skills-section">
      <h2 id='h2'>My skills</h2>
      <div className="skills-container">
        {skills.map((skill) => (
          <SkillBar 
            key={skill.name} 
            skill={skill.name} 
            percentage={skill.level} 
            url={skill.url}
          />
        ))}
      </div>
    </section>
  );
};

export default SkillsSection;